import { Controller } from '@hotwired/stimulus'

// Search controller for live search with debouncing
// Usage: <form data-controller="search" data-search-url-value="/admin/restaurants">
//          <input data-search-target="input" data-action="input->search#search">
//        </form>
export default class extends Controller {
  static targets = ['input', 'results', 'spinner']
  static values = {
    url: String,
    debounce: { type: Number, default: 300 },
    minLength: { type: Number, default: 2 }
  }

  connect () {
    this.timeout = null
  }

  disconnect () {
    if (this.timeout) {
      clearTimeout(this.timeout)
    }
  }

  search () {
    // Clear previous timeout
    if (this.timeout) {
      clearTimeout(this.timeout)
    }

    const query = this.inputTarget.value.trim()

    // Don't search if query is too short
    if (query.length < this.minLengthValue && query.length > 0) {
      return
    }

    // Debounce the search
    this.timeout = setTimeout(() => {
      this.performSearch(query)
    }, this.debounceValue)
  }

  performSearch (query) {
    // Show spinner
    if (this.hasSpinnerTarget) {
      this.spinnerTarget.classList.remove('hidden')
    }

    // Submit the form with Turbo
    this.element.requestSubmit()
  }

  // Called when form submission starts
  submitStart () {
    if (this.hasSpinnerTarget) {
      this.spinnerTarget.classList.remove('hidden')
    }
  }

  // Called when form submission ends
  submitEnd () {
    if (this.hasSpinnerTarget) {
      this.spinnerTarget.classList.add('hidden')
    }
  }

  // Clear search
  clear () {
    this.inputTarget.value = ''
    this.performSearch('')
  }
}
